import React, { lazy } from "react";

const SignIn = lazy(() => import("../pages/SignIn/SignIn"));
const SignUp = lazy(() => import("../pages/SignUp/SignUp"));
const PasswordReset = lazy(
  () => import("../pages/PasswordReset/PasswordReset"),
);
const AppPage = lazy(() => import("../components/AppPage"));
const Logout = lazy(() => import("../pages/Logout/Logout"));

const routes = [
  {
    path: "/",
    exact: true,
    element: <SignIn redirectTo="/signin" />,
  },
  {
    path: "/signin",
    exact: true,
    element: <SignIn />,
  },
  {
    path: "/signup",
    exact: true,
    element: <SignUp />,
  },
  {
    path: "/logout",
    exact: true,
    element: <Logout />,
  },
  {
    path: "/password_reset",
    exact: true,
    element: <PasswordReset redirectTo="/signin" />,
  },
  {
    path: "/home",
    exact: true,
    element: <AppPage />,
  },
  {
    path: "/home/jobsmanager",
    exact: true,
    element: <AppPage />,
  },
  {
    path: "/home/paymentmanager",
    exact: true,
    element: <AppPage />,
  },
  {
    path: "/home/myaccount",
    exact: true,
    element: <AppPage />,
  },
  {
    path: "/videoconference",
    exact: true,
    element: <AppPage />,
  },
  {
    path: "/signdoc/*",
    exact: false,
    element: <AppPage />,
  },
  {
    path: "/*",
    exact: false,
    element: <Logout />,
  },
];

export default routes;
